import { useEffect, useState } from "react";

import usePaginator from "../../../theme/Component/usePaginator";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _DocumentFactory, _ProductionOrder, _single } from "../../../../core/services/dataBean/EntityCatalog";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { toast } from "react-toastify";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { AccountEditor } from "../../../editor/AccountEditor";
import { YearSelector } from "../../../../core/shared/inputs/YearSelector";
import { MonthConstantsEditor } from "../../../RemoteAbstractAction/editors/MonthConstantsEditor";
import { SelectManufacturingStandars } from "../../ManufacturingStandars/SelectManufacturingStandars";
import { SelectAttentionOffice } from "../../ProductionOrder/Components/SelectAttentionOffice";
import { SelectStoreEditor } from "../../../contract/etapa-contrato/contrac/ublinvoice/SelectStore.editor";
import { SelectProductionOrderStateConstants } from "../../ProductionOrder/Components/SelectProductionOrderStateConstants";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { InputDate } from "../../../theme/Input/InputDate";
import { Modal } from "../../../theme/Component/Modal";
import { SelectProductionOrderRequestConstants } from "../../ProductionOrder/Components/SelectProductionOrderRequestConstants";
import { SelectProject } from "../../../erp/cellEditor/BudgetAccountantOperation/SelectProject";
import { RawMaterialRequestCatalog } from "../../ProductionOrder/RawMaterialRequestCatalog/RawMaterialRequestCatalog";
import { FileService } from "../../../../core/services/FileService";
import { RawMaterialRequestDocument } from "./RawMaterialRequestDocument/RawMaterialRequestDocument";


export const ProductionOrderCatalogForRawMaterial = () => {

    const { lista, setLista, bean, setBean, instance, update, handleChange, deleteItemVoid } = useDataBean(_ProductionOrder);

    const paginador = usePaginator();
    const [registers, setRegisters] = useState<number>(15)
    const file = new FileService();
    const [modalsolicitud, setModalsolicitud] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modaldoc, setModaldoc] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalmaterial, setModalmaterial] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [formato, setFormato] = useState<any>([]);
    const _documentos = useDataBean(_DocumentFactory);
    const [form, setForm] = useState<any>({
        IDAccount: NaN,
        Year: _single.getCurrenYear(),
        MonthVigency: NaN,
        IDProject: NaN,
        IDManufacturingStandart: NaN,
        IDAttentionOffice: NaN,
        IDStore: NaN,
    })


    useEffect(() => {
        getLista()
    }, [paginador.page])

    const getLista = () => {
        instance.getProductionOrderCatalogForRawMaterial(form.IDAccount, form.Year, form.MonthVigency, form.IDProject, form.IDManufacturingStandart, form.IDAttentionOffice, form.IDStore, paginador.page, registers).then(
            (resp) => {
                if (resp && Array.isArray(resp.List)) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (registers ?? 15));
                    paginador.setRegiPerPage(registers)

                    resp.List.forEach((element: any) => {
                        if (element) {
                            element.DataBeanProperties.URLLink = file.getUrlFile(element.DataBeanProperties.MediaContext, element.DataBeanProperties.Media);
                            element.DataBeanProperties.Type = 'pdf';
                            element.DataBeanProperties.Filename = element.DataBeanProperties.Media;
                        } else {
                            element.DataBeanProperties.URLLink = "Sin Adjunto";
                        }
                    });

                    setFormato(resp.List[0]);
                    setLista(resp.List);
                }
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const editaItem = () => {
        update().then(
            (resp) => {
                getLista();
                setModal({ ...modal, "view": false })
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const deleteObjec = () => {
        deleteItemVoid(bean.IDProductiveProcessType).then(
            (resp) => {
                getLista();
                setModalC({ ...modalC, "view": false })
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const head = [
        { title: 'No. Solicitud Materia Prima', property: 'IDRawMaterialRequest', visible: true },
        { title: 'Estado de Solicitud de Materia Prima', property: 'RawMaterialRequestStateName', visible: true },
        { title: 'No. Orden de Producción', property: 'IDProductionOrder', visible: true },
        { title: 'Fecha de la Orden de Producción', property: 'ProductionOrderDate', visible: true },
        { title: 'Centro de Fabricación', property: 'IDAttentionOffice', visible: true },
        // { title: 'Fecha Inicio', property: 'InitDate', visible: true },
        // { title: 'Fecha Fin', property: 'UptoDate', visible: true },
        { title: 'Tipo de Solicitud', property: 'TypeName', visible: true },
        { title: 'No Orden del Cliente', property: 'ExternalRequestReference', visible: true },
        { title: 'Cliente/Solicitante', property: 'ContractName', visible: true },
        { title: 'Estandard de Fabricación', property: 'IDManufacturingStardard', visible: true },
        { title: 'Producto a Producir', property: 'ProductName', visible: true },
        { title: 'Unidad de Medida', property: 'MeasurementUnitName', visible: true },
        { title: 'Proyecto', property: 'IDProject', visible: true },
        { title: 'Cantidad a Producir', property: 'Quantity', visible: true },
        // { title: 'Estado', property: 'State', visible: true },
        { title: 'Estado de la Operación', property: 'OrderStateName', visible: true },
        { title: 'Documento Orden de Producción', property: 'POConsecutive', visible: true },
        { title: 'Documento Factura de Venta', property: 'UBLInvoiceConsecutive', visible: true },
        { title: 'Fecha de Creación', property: 'Since', visible: true },
    ]

    const create = () => {
        setBean({
            IDEmployee: _single.getAccountID(),
        });
        setModal({ ...modal, "view": true, "name": "Agregar Orden de Producción" });
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Descargar solicitud', icono: 'ri-chat-download-fill', visible: _single.canDelete(), evento: () => { setModaldoc({ ...modaldoc, "view": true }) } },
            { titulo: 'Consultar Documentos de Traslado de Materia Prima', icono: 'ri-file-search-fill', visible: _single.canDelete(), evento: () => { setModalsolicitud({ ...modalsolicitud, "view": true }) } },
            { titulo: 'Consultar Solicitudes de Materia Prima', icono: 'ri-file-search-line', visible: _single.canDelete(), evento: () => { setModalmaterial({ ...modalmaterial, "view": true }) } },
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            // { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true, "name": `Eliminar Orden de Producción` }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    useEffect(() => {
        if (form.Year && form.MonthVigency >= 0) {
            instance.parseDates(form.Year, form.Year, form.MonthVigency, form.MonthVigency).then(
                (resp) => {
                    setForm({ ...form, "FromDate": resp.FromDate, "UptoDate": resp.UptoDate })
                }
            )
        }
    }, [form.Year, form.MonthVigency])

    const [missingFieldsAdd, setMissingFieldsAdd] = useState<string[]>([]);
    const [missingFieldsForm, setMissingFieldsForm] = useState<string[]>([]);

    const validateAddData = () => {
        if (validataAddForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            editaItem();
        }
    }

    const validataAddForm = () => {
        const requiredFields = [
            "ProductionOrderDate", "IDAttentionOffice", "InitDate", "IDManufacturingStardard", "IDProject", "IDAccount", "Quantity", "Type"
        ];

        let missing = [];
        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }
        setMissingFieldsAdd(missing);
        return missing.length;
    };

    const validateForm = () => {
        if (validateDataForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            getLista();
        }
    }

    const validateDataForm = () => {
        console.log(form)
        const requiredFields = [
            "Year", "MonthVigency", "FromDate", "UptoDate"
        ];

        let missing = [];
        for (let field of requiredFields) {
            if (form[field] === null || form[field] === undefined || form[field] === "" || Number.isNaN(form[field])) {
                missing.push(field);
            }
        }
        console.log(missing)
        setMissingFieldsForm(missing);
        return missing.length;
    };
    const verDocumentos = () => {



    }
    return (
        <BasicPage titulo="Solicitudes de Material de Ordenes de Producción" >
            <div className="row">
                <div className="col-md-4">
                    <AccountEditor idAccount={null} label="Cliente" onChange={(e) => { setForm({ ...form, "IDAccount": e.IDAccount }) }} />
                </div>
                <div className="col-md-4">
                    <label className={`${missingFieldsForm.includes('Year') ? 'has-error' : ''}`}>Año/Vigencia</label>
                    <YearSelector tittle=" " onChange={(e) => { setForm({ ...form, "Year": e }) }} />
                </div>
                <div className="col-md-4">
                    <label className={`${missingFieldsForm.includes('MonthVigency') ? 'has-error' : ''}`}>Mes</label>
                    <MonthConstantsEditor idSelect={form.MonthVigency} onChange={(e) => { setForm({ ...form, "MonthVigency": e }) }} label=" " name="" />
                </div>
                <div className="col-md-6">
                    <label>Proyecto</label>
                    <SelectProject idSelector={form.IDProject} onChange={(e) => { setForm({ ...form, "IDProject": e }) }} />
                </div>
                <div className="col-md-6">
                    <SelectManufacturingStandars idSelector={form.IDManufacturingStandart} onChange={(e) => { setForm({ ...form, "IDManufacturingStandart": e }) }} label="Estandard de Fabricación" />
                </div>
                <div className="col-md-6">
                    <SelectAttentionOffice idSelector={form.IDAttentionOffice} onChange={(e) => { setForm({ ...form, "IDAttentionOffice": e }) }} label="Centro de Fabricación" />
                </div>
                <div className="col-md-6">
                    <SelectStoreEditor idSelector={form.IDStore} label="" onChange={(e) => { setForm({ ...form, "IDStore": e.IDStore }) }} />
                </div>
                <div className="col-md-6">
                    <SelectProductionOrderStateConstants idSelector={form.State} onChange={(e) => { setForm({ ...form, "State": e }) }} label="Estado de la Orden de Producción" />
                </div>
                <div className="col-md-6 mt-4">
                    <BasicButton eventClick={validateForm} icon="ri-search-line" children={"Buscar"} />
                </div>

                <div className="col-md-12">
                    <Modal modal={modalmaterial} updateModal={setModalmaterial}>
                        <>
                            <RawMaterialRequestCatalog idProductionOrder={bean.IDProductionOrder} productionOrderDate={bean.ProductionOrderDate} />
                        </>
                    </Modal>
                    <Modal modal={modalsolicitud} updateModal={setModalsolicitud}>
                        <>
                            <RawMaterialRequestDocument idRawMaterialRequest={bean.IDRawMaterialRequest} />
                        </>
                    </Modal>
                    <Modal modal={modaldoc} updateModal={setModaldoc}>
                        <>
                            <div className="row">
                                <div className="col-md-12">
                                    {formato?.DataBeanProperties?.URLLink && (
                                        <div className="row">
                                            <div className="col-md-12 mt-3">
                                                <label>Descarga en el Siguiente Link:*</label>
                                            </div>
                                            <div className="col-md-12 mt-3">
                                                <a href={formato.DataBeanProperties?.URLLink} target="_blank" rel="noopener noreferrer">
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <strong>{formato.DataBeanProperties?.Filename}</strong>

                                                        </div>
                                                        <div className="col-md-12">
                                                            <small>{formato.DataBeanProperties?.URLLink}</small>
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>

                        </>
                    </Modal>
                    <BasicTable
                        listButtons={listaBotones()}
                        head={head} body={lista}
                        rowSet={setBean}
                        iconButtons={iconButtonsItem}
                        pageTop={paginador.page}
                        next={paginador.next}
                        back={paginador.back}
                        records={paginador}
                        customRows={registers} />
                </div>


                <div className="col-md-12">
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteObjec}>
                        <strong>Eliminar Informacion de {bean.IDProductiveProcessType} - {bean.Name}</strong>
                    </ModalConfirm>
                </div>

                <div className="col-md-12">
                    <Modal modal={modal} updateModal={setModal} eventModal={validateAddData}>
                        <div className="row">
                            <div className="col-md-6">
                                <label className={`${missingFieldsAdd.includes('ProductionOrderDate') ? 'has-error' : ''}`}>Fecha de la Orden de Producción</label>
                                <InputDate name="date" value={bean.ProductionOrderDate} label=" " setDate={(e) => { setBean({ ...bean, "ProductionOrderDate": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFieldsAdd.includes('IDAttentionOffice') ? 'has-error' : ''}`}>Centro de Fabricación</label>
                                <SelectAttentionOffice idSelector={bean.IDAttentionOffice} onChange={(e) => { setBean({ ...bean, "IDAttentionOffice": e }) }} label=" " />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFieldsAdd.includes('InitDate') ? 'has-error' : ''}`}>Fecha de Inicio</label>
                                <InputDate name="date" value={bean.InitDate} label=" " setDate={(e) => { setBean({ ...bean, "InitDate": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Fecha de Fin</label>
                                <InputDate name="date" value={bean.UptoDate} label=" " setDate={(e) => { setBean({ ...bean, "UptoDate": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFieldsAdd.includes('Type') ? 'has-error' : ''}`}>Tipo de Solitud</label>
                                <SelectProductionOrderRequestConstants idSelector={bean.Type} onChange={(e) => { setBean({ ...bean, "Type": e }) }} label=" " />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFieldsAdd.includes('IDManufacturingStardard') ? 'has-error' : ''}`}>Estandard de Fabricación</label>
                                <SelectManufacturingStandars idSelector={bean.IDManufacturingStardard} onChange={(e) => { setBean({ ...bean, "IDManufacturingStardard": e.IDManufacturingStardard, "ProductName": e.ProductName, "MeasurementUnitName": e.MeasurementUnitName, "MeasurementUnitCode": e.MeasurementUnitCode }) }} returnType="Object" label=" " />
                            </div>
                            {bean.IDManufacturingStardard &&
                                <>
                                    <div className="col-md-6">
                                        <label >Producto a Producir</label>
                                        <input type="text" value={bean.ProductName} className="form-control" disabled />
                                    </div>
                                    <div className="col-md-6">
                                        <label >Unidad de Medida</label>
                                        <input type="text" value={`${bean.MeasurementUnitCode ?? ""} - ${bean.MeasurementUnitName ?? ""}`} className="form-control" disabled />
                                    </div>
                                </>
                            }
                            <div className="col-md-6">
                                <label className={`${missingFieldsAdd.includes('IDProject') ? 'has-error' : ''}`}>Proyecto</label>
                                <SelectProject idSelector={bean.IDProject} onChange={(e) => { setBean({ ...bean, "IDProject": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFieldsAdd.includes('IDAccount') ? 'has-error' : ''}`}>Cliente Final</label>
                                <AccountEditor idAccount={bean.IDAccount} label=" " onChange={(e) => { setBean({ ...bean, "IDAccount": e.IDAccount }) }} />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFieldsAdd.includes('Quantity') ? 'has-error' : ''}`}>Cantidad a Producir</label>
                                <input type="number" name="Quantity" className="form-control" value={bean.Quantity} onChange={handleChange} />
                            </div>
                            {/* <div className="col-md-6">
                                <label className={`${missingFieldsAdd.includes('State') ? 'has-error' : ''}`}>Estado</label>
                                <SelectProductionOrderStateConstants idSelector={bean.State} onChange={(e) => { setBean({ ...bean, "State": e }) }} label=" " />
                            </div> */}
                        </div>
                        {/* <PrintJson json={bean} /> */}
                    </Modal>
                </div>
            </div>
        </BasicPage>

    )
}



